import styled from "@emotion/styled";



export const ConnectionImg = styled.img`
    width: 100%;
    margin-right : 12px;
`;